module.exports = __webpack_public_path__ + "img/clipboard_1.8ed1906d.png";